<template>
  <ul class="fz-18 text-white pl-5 list-disc flex flex-col gap-6">
    <li
        v-for="item in items"
        :key="item"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "markedList",
  props: ['items']
}
</script>

<style scoped>

</style>